export default {
  name: "Nama",
  tel: "Telepon",
  save: "Simpan",
  confirm: "Konfirmasi",
  cancel: "Batal",
  delete: "Hapus",
  complete: "Selesai",
  loading: "Memuat...",
  telEmpty: "Silakan isi nomor telepon",
  nameEmpty: "Silakan isi nama",
  nameInvalid: "Silakan masukkan nama yang benar",
  confirmDelete: "Yakin ingin menghapus?",
  telInvalid: "Silakan masukkan nomor telepon yang benar",
  SelectYearMonthDay: "Pilih Tahun, Bulan, Hari",
  vanCalendar: {
    end: "Akhir",
    start: "Mulai",
    title: "Pilih Tanggal",
    confirm: "Konfirmasi",
    startEnd: "Mulai/Akhir",
    weekdays: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
    monthTitle: (year, month) => `${year} Tahun ${month} Bulan`,
    rangePrompt: (maxRange) =>
      `Jumlah hari tidak boleh melebihi ${maxRange} hari`,
  },
  vanCascader: {
    select: "Silakan pilih",
  },
  vanContactCard: {
    addText: "Tambah Kontak",
  },
  vanContactList: {
    addText: "Kontak Baru",
  },
  vanPagination: {
    prev: "Halaman Sebelumnya",
    next: "Halaman Berikutnya",
  },
  vanPullRefresh: {
    pulling: "Tarik ke bawah untuk menyegarkan...",
    loosing: "Lepaskan untuk menyegarkan...",
  },
  vanSubmitBar: {
    label: "Total:",
  },
  vanCoupon: {
    unlimited: "Tanpa batasan penggunaan",
    discount: (discount) => `${discount} Diskon`,
    condition: (condition) => `Dapat digunakan setelah belanja Rp${condition}`,
  },
  vanCouponCell: {
    title: "Kupon",
    tips: "Tidak ada yang tersedia",
    count: (count) => `${count} tersedia`,
  },
  vanCouponList: {
    empty: "Tidak ada kupon",
    exchange: "Tukar",
    close: "Tidak gunakan kupon",
    enable: "Tersedia",
    disabled: "Tidak tersedia",
    placeholder: "Masukkan kode kupon",
  },
  vanAddressEdit: {
    area: "Wilayah",
    postal: "Kode Pos",
    areaEmpty: "Silakan pilih wilayah",
    addressEmpty: "Silakan isi alamat lengkap",
    postalEmpty: "Format kode pos salah",
    defaultAddress: "Jadikan sebagai alamat utama",
    telPlaceholder: "Nomor HP penerima",
    namePlaceholder: "Nama penerima",
    areaPlaceholder: "Pilih Provinsi / Kota / Kecamatan",
  },
  vanAddressEditDetail: {
    label: "Alamat Lengkap",
    placeholder: "Nama jalan, nomor rumah, lantai, nomor kamar, dll",
  },
  vanAddressList: {
    add: "Tambah Alamat",
  },

  realName: "姓名",
  idCard: "身份证",

  unionManagement: {
    GuildRegistration: "Pendaftaran Guild",
    GuildSettlementWelcomeLine1: "Selamat datang di",
    GuildSettlementWelcomeLine2: "guild Rain Chat",
    GuildSettlementFormBanner: "Silakan isi informasi bergabung dengan guild",
    ApplicantID: "ID Pemohon",
    GuildName: "Nama Guild",
    PleaseGuildName: "Silahkan masukkan nama guild",
    PleaseGuildID: "Harap masukkan Name Guild",
    PleaseInformation: "Harap masukkan informasi kontak Anda",
    PlatformsWith: "Platform yang pernah Anda bekerjasama",
    ListOfplatforms: "Daftar platform yang pernah Anda bekerjasama",
    GuildSize: "Skala Guild",
    EstimatedNumber: "Perkiraan jumlah host guild",
    Notes:
      "Catatan: Anda dapat menghubungi ketua guild atau anggota guild untuk mendapatkan ID guild.",
    Submit: "Kirim",
    SubmitSuccess: "Berhasil dikirim",
    MyGuild: "Guild Saya",
    VoiceHallOnboarding: "Pendaftaran Ruang Suara",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "Silakan isi informasi bergabung ke ruangan",
    VoiceHallName: "Nama Guild Suara",
    PleaseVoiceHallName: "Silahkan masukkan nama guild suara",
    VoiceHallRealName: "Nama asli",
    PleaseVoiceHallRealName: "Silakan masukkan nama asli Anda",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Harap masukkan informasi kontak Anda",
    PlatformsCollaborated: "Platform yang pernah Anda bekerjasama",
    ListPlatformsCollaborated: "Daftar platform yang pernah Anda bekerjasama",
    VoiceHallScale: "Skala Guild Suara",
    EstimatedAnchors: "Perkiraan jumlah anchor ruang suara",
    CertificationType: "Jenis Sertifikasi",
    VoiceHall: "Ruang Suara",
    VoiceGuild: "Guild Suara",
    HostName: "Nama Host",
    GuildJoinDate: "Tanggal Bergabung dengan Guild",
    TotalMembers: "Total Jumlah Anggota Guild",
    TotalPeople: "Jumlah Total Orang",
    RoomNicknameLabel: "Nama ruangan",
    DataDetails: "Rincian Data",
    PleaseHostID: "Harap masukkan ID host",
    Search: "Cari",
    KickOut: "Tendang Keluar",
    NoData: "Data tidak tersedia",

    InformationData: "Data Informasi",
    Name: "Nama",
    PleaseID: "Pastikan sesuai dengan nama pada KTP Anda.",
    IdentityCard: "KTP",
    YourIDnumber: "Nomor KTP Anda",
    IDPhoto: "Foto KTP",
    PleasePhoto: "Silahkan unggah foto KTP Anda.",
    FrontofID: "Sisi Depan KTP",
    BackofID: "Sisi Belakang KTP",
    NotePlease:
      "Catatan: Unggah foto Anda memegang KTP. Wajah harus jelas tanpa halangan, dan foto serta nomor KTP harus dapat terbaca.",
    Country: "Negara",
    SelectCountryorRegion: "Pilih Negara/Wilayah",
    BankName: "Nama Bank",
    Pleasebankname: "Masukkan nama bank tempat Anda membuka rekening.",
    BankCardNumber: "Nomor Rekening",
    Pleasebankcardnumber: "Masukkan nomor rekening bank Anda.",
    BankCardHolder: "Pemilik Rekening",
    Pleasebankcardholder: "Masukkan nama pemilik rekening.",
    PhoneNumber: "Nomor Ponsel",
    Enterphonenumber: "Masukkan nomor ponsel yang valid.",
    Notebankaccount: "Catatan: Masukkan nomor ponsel yang terdaftar di bank.",
    WhatsAppContactInformation: "Kontak WhatsApp",
    Pleaseownnumber: "Pastikan Anda memasukkan nomor Anda sendiri.",
    Notecollaborationmatters:
      "Catatan: Kontak WhatsApp yang diberikan oleh guild akan dianggap sebagai satu-satunya kontak untuk urusan kerja sama.",
    Email: "Email",
    Pleaseemailaddress: "Pastikan Anda memasukkan alamat email Anda sendiri.",
    Notematters:
      "Catatan: Email yang disediakan oleh guild akan dianggap sebagai satu-satunya kontak untuk urusan kerja sama.",
    BasicInformationSection: "Informasi Dasar",
    RemarksInformationSection: "Informasi Tambahan",

    SpecialGiftDetails: "Detail Hadiah Efek Khusus",

    CurrentDate: "Tanggal Saat Ini",
    GoldCoinTransactions: "Gold Bean Penghasilan Beruntung",
    LiveStreamingDuration: "Durasi Siaran Langsung",
    GoldBeanEarnings: "Pendapatan Kacang",
    EffectiveDays: "Hari Aktif",
    WarningCount: "Jumlah Peringatan",

    give: "berikan",

    pleasewait: "Permintaan sedang diproses, harap tunggu...",

    JoinGuild: "Bergabung dengan Guild",
    GuildId: "ID Guild",
    PlaceholderGuildId: "Silahkan Masukkan ID Guild",
    PlaceholderInvitationCode: "Silakan masukkan kode undangan guild Anda",

    InvitationCode: "Kode undangan",

    noMore: "Tidak ada lagi",

    Recommendation: "Rekomendasi (Opsional)",
    nightLiveTime: "Waktu tertentu",

    // Halaman Data Guild
    GuildTotalData: "Data total guild",
    StatDayUnit: "",
    GuildIncome: "Pendapatan Guild",
    AnchorIncome: "Pendapatan Anchor",
    EffectiveLive: "Live Efektif",
    EffectiveDays: "Hari Efektif",
    Income: "Pendapatan",
    Duration: "Durasi",

    // Join Us Page
    JoinUs: "Bergabung dengan Kami",
    JoinUsWelcome: "Hi, selamat bergabung dengan kami～",
    JoinUsSelectMethod: "Silakan pilih cara bergabung",
    JoinUsVideoGuild: "Bergabung sebagai Guild Video",
    JoinUsVideoGuildDesc: "Anda akan fokus pada streaming video",
    JoinUsAudioGuild: "Bergabung sebagai Guild Suara",
    JoinUsAudioGuildDesc: "Anda akan fokus pada streaming suara",
    JoinUsBack: "Kembali",
  },

  coinManagement: {
    myGoldenbeans: "Kacang Emas Saya",
    Withdraw: "Tarik Tunai",
    ExchangeGoldCoins: "Tukar",
    HostInformation: "Informasi Host",
    WithdrawalCurrency: "Mata Uang Penarikan",
    SelectWithdrawalCurrency: "Silakan pilih mata uang penarikan",
    FiatCurrency: "Mata Uang Fiat",
    PleaseSelectWithdrawalCurrency: "Silakan pilih mata uang penarikan",
    tips: "Catatan：",
    tipsp0: "Rasio penarikan: 10.000 kacang emas = 0,5 USD",
    tipsp1:
      "Ambang batas penarikan: 100.000 biji emas, penarikan hanya dapat dilakukan dalam kelipatan 10.000 (penarikan pertama memerlukan 200.000 biji emas, setelah penarikan berhasil ambang batas turun menjadi 100.000)",
    tipsp2:
      "Hubungkan akun penarikan. Karena metode pembayaran yang beragam dan kurangnya dokumen tetap di luar negeri, sistem belakang memerlukan berbagai jenis verifikasi saat menambahkan akun sebagai kepala keluarga (metode pembayaran spesifik tergantung pada situasi saat ini).",
    tipsp3: "Host perlu diverifikasi",
    tipsp4: "Hubungkan nomor telepon",
    tipsp5:
      "Jika salah satu langkah di atas tidak selesai, penarikan tidak dapat dilakukan. Pada saat ini, halaman akan memberi tahu pengguna atau membimbing mereka untuk menyelesaikan proses.",
    tipsp6: "① Hanya pemberitahuan",
    tipsp7:
      "② Alihkan ke halaman penghubungan nomor telepon. Setelah selesai, kembali ke halaman sebelumnya.",
    tipsp8:
      "③ Alihkan ke halaman verifikasi identitas. Setelah selesai, kembali ke halaman sebelumnya.",
    tipsp9:
      "④ Alihkan ke halaman penghubungan akun. Setelah selesai, kembali ke halaman sebelumnya.",

    tipsp10:
      "Pengambilan uang akan memiliki biaya tertentu, dan biaya juga akan berbeda tergantung pada saluran yang berbeda.",
    tipsp11: "1. Rasio penukaran: 1000 kacang emas = 500 koin emas",
    tipsp12: "2. Minimal penukaran 5000 kacang emas, harus kelipatan 1000",
    tipsp13:
      "3. Penukaran yang berhasil tidak dapat dibatalkan, harap berhati-hati",
    num: "Jumlah",
    Custom: "Kustom",
    PleaseEnter: "silahkan masukkan",
    Redeem: "Tukarkan",
    SelectType: "Pilih Jenis",
    GoldBeans: "Kacang Emas",
    GoldCoin: "Koin",
    WithdrawalAmount: "Jumlah Penarikan",
    PleaseNum: " Masukkan jumlah coin yang ingin ditarik",
    All: "Semua",
    Withdraw: "Tarik",

    Incomedetails: "Rincian pendapatan",
    Expensedetails: "Rincian pengeluaran",
    Nobeans: "Tidak ada biji emas yang dapat ditukar",

    balance: "Saldo",

    Record: "Riwayat Transaksi",
    WithdrawalRecord: "Riwayat Penarikan",
  },

  familyMain: {
    anchorList: "Daftar Anchor",
    anchorData: "Data Anchor",
    guildData: "Data guild",
    guildSummaryTitle: "Ringkasan guild",
    guildList: "Daftar guild",
    micTime: "Waktu Mic",
    micTimeData: "Data waktu Mic",
    beansDetail: "Detail Kacang",
    beansDetailData: "Data detail Kacang",
    withdrawDetail: "Detail penarikan",
    withdrawDetailData: "Data detail penarikan",
    roomData: "Data ruangan",
    roomDataData: "Data ruangan",
    distributeBeans: "Distribusi Kacang",
    distributeBeansData: "Data distribusi Kacang",
    privateShareStats: "Statistik pesan/berbagi",
    privateShareStatsData: "Data statistik pesan/berbagi",
    roomTurnover: "Omset ruangan",
    roomTurnoverData: "Data omset ruangan",
    incomeRecord: "Catatan pendapatan",
    incomeRecordData: "Data catatan pendapatan",
    knapsackGiftDetail: "Detail hadiah tas",
    knapsackGiftData: "Data hadiah tas",
    roomFilterTitle: "Filter Ruangan",
    roomFilterConfirm: "Selesai",
    allRooms: "Semua ruangan",
    selectRoom: "Pilih ruangan",
  },
  anchorList: {
    countLabel: "【{count} anchor】",
    searchPlaceholder: "Masukkan ID anchor",
    search: "Cari",
    joinTimeLabel: "Waktu bergabung：",
    noData: "Tidak ada data",
    nickNameFallback: "Nama anchor",
    invalidUserId: "Silakan masukkan ID berupa angka",
  },

  anchorCenter: {
    todayLiveData: "Data live hari ini",
    time: "Waktu",
    duration: "Durasi",
    income: "Pendapatan Kacang Emas Beruntung",
    giftRecord: "Riwayat hadiah",
    withdraw: "Penarikan",
    tipsUpdate: "Catatan: Data hari ini diperbarui setiap menit",
    overallData: "Data keseluruhan",
    totalDays: "Total hari",
    totalDuration: "Total durasi",
    totalTurnover: "Total Kacang Emas Beruntung",
    totalIncome: "Total gaji pokok",
    totalBeans: "Total kacang emas",
    luckyBeans: "Kacang emas keberuntungan",
    specialBeans: "Kacang emas efek khusus",
    baseSalary: "Gaji pokok",
    totalIncomeLabel: "Total pendapatan",
    dataListMonth: "Daftar data [{month}]",
    filter: "Filter",
    date: "Tanggal",
    turnover: "Omset",
    beans: "Kacang emas",
    zeroTime: "0j 0m",
    year: "",
    month: "",
    anchorTotalData: "Data total anchor",
    anchorNicknamePlaceholder: "Nama panggilan anchor",
    myGuild: "Guild saya",
    guildNicknamePlaceholder: "Nama panggilan guild",
    anchorDataSection: "Data anchor",
    todayDataTitle: "Data hari ini",
    liveStreamDuration: "Durasi live",
    totalGoldBeans: "Total kacang emas",
    nextDayLuckyReward: "Hadiah beruntung hari berikutnya",
    specialExtraReward: "Hadiah tambahan efek khusus",
    weekLuckyReward: "Hadiah beruntung minggu ini",
    estimatedTotalEarnings: "Perkiraan total pendapatan",
    grandTotal: "Total",
  },

  salaryMain: {
    searchPlaceholder: "Masukkan ID anchor untuk cari",
    dateSelect: "Pilih tanggal",
    byDay: "Per hari",
    byRange: "Per rentang",
    searchTime: "Waktu pencarian",
    to: " hingga ",
    dataSummary: "Ringkasan data",
    totalMicTime: "Total waktu Mic",
    totalHeartGiftTurnover: "Total Kacang Emas Keberuntungan",
    totalLuxuryGiftTurnover: "Total Kacang Emas",
    member: "Anggota",
    anchorProfile: "Profil Anchor",
    micTime: "Waktu Mic",
    heartGiftTurnover: "Kacang Emas Keberuntungan",
    luxuryGiftTurnover: "Total Kacang Emas",
    roomNumber: "Nomor kamar",
    pleaseSelectTime: "Pilih waktu",
    pleaseEnterNumber: "Silakan masukkan angka",
    selectAll: "Pilih semua",
    minute: "menit",
    second: "detik",
    anchorTotalData: "Data total anchor",
    totalSpecialEffectBeans: "Total kacang emas efek",
    totalAllBeans: "Total kacang emas",
  },

  micTime: {
    searchPlaceholder: "Masukkan ID anchor",
    search: "Cari",
    dateSelect: "Pilih tanggal",
    today: "Hari ini",
    thisWeek: "Minggu ini",
    lastWeek: "Minggu lalu",
    totalMicTime: "Total waktu Mic",
    date: "Tanggal",
    anchorInfo: "Info Anchor",
    micTime: "Waktu Mic",
    pleaseSelectTime: "Pilih waktu",
    selectAll: "Pilih semua",
    minute: "menit",
    second: "detik",
  },

  anchroOtayonii: {
    dateSelect: "Pilih tanggal",
    byDay: "Per hari",
    byRange: "Per rentang",
    searchTime: "Waktu pencarian",
    to: " hingga ",
    dataSummary: "Ringkasan data",
    totalLuckyGift: "Total hadiah Lucky",
    totalSpecialGift: "Total hadiah Special",
    totalKnapsackGift: "Total hadiah tas",
    anchorInfo: "Info Anchor",
    luckyGift: "Hadiah Lucky",
    specialGift: "Hadiah Special",
    knapsackGift: "Hadiah tas",
    pleaseSelectTime: "Pilih waktu",
    selectAll: "Pilih semua",
  },

  roomCm: {
    dateSelect: "Pilih tanggal",
    today: "Hari ini",
    thisWeek: "Minggu ini",
    lastWeek: "Minggu lalu",
    dataSummary: "Ringkasan data",
    totalTurnover: "Total Kacang Emas Keberuntungan",
    totalTurnoverBeans: "Total Kacang Emas",
    date: "Tanggal",
    heartGiftTurnover: "Kacang Emas Keberuntungan",
    specialGiftTurnover: "Total Kacang Emas",
    room: "Ruangan",
    pleaseSelectTime: "Pilih waktu",
    selectAll: "Pilih semua",
    minute: "menit",
    second: "detik",
  },

  weekProfit: {
    dateSelect: "Pilih tanggal",
    time: "Waktu",
    type: "Tipe",
    beans: "Kacang",
    pleaseSelectTime: "Pilih waktu",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "Jumlah Penarikan",
    withdrawStatus: "Status Penarikan",
    NoData: "Tidak ada data",

    UnderReview: "Dalam Peninjauan",
    Processing: "Dalam Proses",
    Completed: "Selesai",
    Rejected: "Ditolak",
    Failed: "Gagal",

    Pending: "Menunggu",
    Success: "Berjaya",
    NoMore: "Tiada lagi",
    PleaseWait: "Sila tunggu...",
    PleaseSelect: "Sila pilih",
    Date: "Tarikh",
    RealAmount: "Jumlah Sebenar",
    Fee: "Yuran",
    Status: "Status",
    Remark: "Catatan",
  },

  contactUs: {
    Officialcustomerservice: "Layanan Pelanggan Resmi",
    ContactUs: "Hubungi Kami",
    Issueofguild: "Masalah Pendaftaran Guild",
  },

  myInvitation: {
    MyGoldBeans: "Kacang Emas Saya",
    Share: "Bagikan untuk Mengundang Lebih Banyak Teman",
    CopyLink: "Salin Tautan",
    GoldCoinEarnedToday: "Koin Emas yang Diperoleh Hari Ini",
    TotalGoldCoin: "Total Koin Emas Terkumpul",
    tips: "Undang dan Hubungkan Pengguna Baru untuk Mengisi Saldo Berapa Saja dan Dapatkan Hadiah 1% Emas",
    tips2: "Tidak dapat mengikat setelah 48 jam pendaftaran",
    MyInvitations: "Undangan Saya",
    BillingDetails: "Rincian Tagihan",
    Total: "Total",
    People: "Orang",
    GoldCoinGiven: "Koin Emas yang Diberikan",
    GiveGoldCoin: "Tambah+",
    InvitationLink: "Tautan undangan",
    ShareQR: "Bagikan kode QR",
    InviteCount: "Jumlah undangan",
    RevenueBeans: "Kacang emas",
    InvitationDetails: "Detail undangan",
    EarningsDetails: "Detail pendapatan",
    NickNameLabel: "Nama panggilan",
    SaveImage: "Simpan Gambar",
    QRScanHint: "Pindai kode QR atau gunakan tautan undangan untuk bergabung",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "kacang emas",
    CommissionRate: "Komisi {rate}%",
  },

  userMisconduct: {
    title1: "Pelanggaran Konten I",
    p1: "1.Menampilkan atau Menyebarkan Konten Terbatas:",
    p2: "Termasuk menyebarkan konten pornografi, vulgar, kekerasan, atau rasis melalui pesan pribadi, siaran langsung, atau fitur lain Rain Live.",
    p3: "2.Menyebarkan Ujaran Kebencian:",
    p4: "Dilarang membuat ujaran kebencian yang ditujukan kepada agama, ras, politik, atau identitas negara.",
    p5: "3.Promosi atau Rekrutmen:",
    p6: "Dilarang mengundang pengguna untuk bergabung dengan aplikasi atau platform lain melalui siaran langsung, pesan pribadi, atau komentar yang ditinjau.",
    title2: "Konsekuensi",
    p7: "Akun, perangkat, atau alamat IP yang melanggar dapat diblokir.",

    title3: "Pelanggaran Konten II",
    p8: "1.Membagikan Informasi Pribadi:",
    p9: "Dilarang menyebarkan informasi pribadi seperti nomor telepon, ID akun, akun Facebook, atau foto melalui siaran langsung, komentar, atau pesan pribadi Rain Live.",
    p10: "2.Penyalahgunaan Akun:",
    p11: "Dilarang memberikan, menyewakan, atau menjual akun Rain Live kepada orang lain.",
    p12: "3.Menggunakan Informasi Pribadi:",
    p13: "Dilarang menggunakan atau menyebarkan informasi pribadi (foto, nama panggilan, dll.) tanpa izin pengguna untuk keuntungan pribadi atau menyerang orang lain secara jahat.",
    title4: "Konsekuensi",
    p14: "Pengguna yang melanggar akan diblokir secara permanen.",
  },

  landingPage: {
    info1: "Lingkaran Rain Live",
    info2: "Pembelian Internal Apl",
    item1: "45K Ulasan",
    item2: "Unduh",
    item3: "Level 3 3+",
    btn: "Unduh",
    title: "Tentang Rain Live",
    content:
      "Rain Live adalah aplikasi streaming langsung online yang menyentuh hati untuk semua orang, termasuk suara, video, hiburan, dan game. Platform ini mengumpulkan host dengan profil tinggi dan berfungsi sebagai platform streaming langsung yang kaya akan konten. Pertandingan PK intens, acara tanpa henti, hadiah keren, dan Experience seperti raja menunggu.",
    tips: "Rain Live menduduki peringkat pertama dalam daftar aplikasi sosial gratis populer.",
  },

  equityLevel: {
    Experience: "Poin Experience",
    Level: "Level Saat Ini",
    Berikutnya: "Jarak ke Level Berikutnya",
    title1: "Keistimewaan Level",
    desc1:
      "Semakin tinggi levelnya, semakin terhormat level ikon, dan semakin mudah mendapatkan perhatian dari host favorit Anda.",
    title2: "Cara Meningkatkan",
    desc2:
      "1、Level pengguna ditentukan oleh jumlah Experience yang diperoleh dari konsumsi hadiah.",
    desc3:
      "2、Anda dapat meningkatkan level dengan mengirim hadiah setiap hari untuk mendapatkan poin Experience.",
    desc4:
      "3、Hadiah keberuntungan, setiap 1 koin yang dibelanjakan, Anda akan mendapatkan 1 poin Experience.",
    desc5:
      "4、Hadiah efek khusus, setiap 1 koin yang dibelanjakan, Anda akan mendapatkan 10 poin Experience.",
    title3: "Keistimewaan Level",
    desc6:
      "Semakin tinggi levelnya, semakin terhormat level ikon, dan semakin mudah mendapatkan perhatian dari pengguna.",
    title3: "Cara Meningkatkan",
    desc7:
      "1、Level host ditentukan oleh jumlah Experience yang diperoleh dari menerima hadiah.",
    desc8:
      "2、Anda dapat meningkatkan level dengan menerima hadiah setiap hari untuk mendapatkan poin Experience.",

    title6: "Tingkat pengguna",
    title7: "Tingkat",
    title8: "Lencana tingkat",
    title9: "Tingkat Host",
    title10: "Total poin pengalaman",

    LevelDescription: "Deskripsi tingkat",
    tabUser: "Pengguna",
    tabEx: "Koin Ex",
    tabAnchor: "Host",
    titleOverview: "Ikhtisar Level Kekayaan",
    nickNameUser: "Nama pengguna",
    nickNameAnchor: "Nama host",
    nickNameEx: "Nama pengguna",
    exPrivilegeDesc:
      "Semakin tinggi levelnya, semakin terhormat level ikon, dan semakin mudah mendapatkan perhatian dari pengguna.",
    exDesc1:
      "1、Level Ex ditentukan oleh jumlah Experience yang diperoleh dari konsumsi hadiah.",
    exDesc2:
      "2、Anda dapat meningkatkan level dengan mengirim hadiah setiap hari untuk mendapatkan poin Experience.",
    exDesc3:
      "3、Hadiah keberuntungan, setiap 1 koin yang dibelanjakan, Anda akan mendapatkan 1 poin Experience.",
    exDesc4:
      "4、Hadiah efek khusus, setiap 1 koin yang dibelanjakan, Anda akan mendapatkan 10 poin Experience.",
    anchorPrivilegeDesc:
      "Semakin tinggi levelnya, semakin terhormat level ikon, dan semakin mudah mendapatkan perhatian dari pengguna.",
    anchorDesc1:
      "1、Level host ditentukan oleh jumlah Experience yang diperoleh dari menerima hadiah.",
    anchorDesc2:
      "2、Anda dapat meningkatkan level dengan menerima hadiah setiap hari untuk mendapatkan poin Experience.",
  },

  applyJoin: {
    tips1: "Masukkan akun WhatsApp Anda",
    title2: "Persyaratan foto",
    tips2:
      "Harap tunjukkan wajah dan tubuh bagian atas Anda, dan posisikan tangan Anda seperti kucing",
    tips3:
      "Foto ini akan diambil untuk tujuan review perusahaan dan pihak berwenang akan menjaga kerahasiaannya.",
    tips4: "Foto harus merupakan foto diri Anda sendiri.",
    title3: "Persyaratan video",
    tops5: "Video harus menampilkan orang tersebut.",
    tips6: "Video sebaiknya memiliki durasi antara 10 hingga 20 detik.",
    status1: "Kirim untuk ditinjau",
    status2: "Sedang ditinjau",
    status3: "Pemeriksaan berhasil",
    status4: "Pemeriksaan gagal",

    LiveMode: "Mode siaran langsung",
    Video: "Video",
    Voice: "Suara",

    MP4: "Silahkan pilih video dalam format MP4",
    pngOrJpg: "Silahkan unggah gambar dalam format PNG atau JPG",
    UploadingWait: "Sedang mengunggah, harap tunggu",
    CompleteInformation: "Harap lengkapi informasi",
    TabPersonalStreamer: "Verifikasi Host",
    TabJoinGuild: "Bergabung dengan guild",
    faceVerifyTitle: "Verifikasi Wajah",
    faceVerifyPending: "Menunggu verifikasi",
    faceVerifyVerified: "Terverifikasi",
    faceVerifyError:
      "Anda telah memverifikasi akun lain dan tidak dapat diverifikasi",
    faceVerifyRequired: "Harap selesaikan verifikasi wajah terlebih dahulu",
    faceVerifyNotSupported:
      "Verifikasi wajah tidak didukung di lingkungan saat ini",
    faceVerifyStart: "Mulai",
    faceVerifyRetry: "Coba lagi",
    faceVerifySuccess: "Verifikasi berhasil",
    faceVerifyFail: "Verifikasi gagal",
  },
  cancelAccount: {
    title: "Ajukan Penghapusan Akun",
    tips: "Informasi berikut akan dihapus dan tidak dapat dipulihkan:",
    p1: "Setelah akun dihapus, semua informasi akan dihapus secara permanen (termasuk pengikut, penggemar, dll.), dan layanan berbayar yang telah Anda beli tidak akan disimpan atau dapat dipindahkan ke akun lain (seperti VIP, nomor cantik, bingkai avatar, dll.).",
    p2: "Akun Facebook, Twitter, Apple, dan Google yang terhubung akan dilepaskan. Setelah dilepaskan, Anda dapat mendaftar ulang.",
    p3: "Informasi aplikasi Host Anda akan dilepaskan, dan setelah dilepaskan, Anda dapat menghubungkannya ke akun lain. (Jika Anda adalah pengguna Host live streaming, informasi Host Anda dapat diverifikasi ulang untuk siaran langsung).",
    p4: "Setelah akun dihapus, sisa koin emas, berlian, poin pengalaman, kendaraan, status bangsawan, dan data pendapatan lainnya akan dihapus. Kerugian yang terjadi akan menjadi tanggung jawab pemohon penghapusan akun.",
    p5: "Jika Anda adalah ketua serikat, mengajukan penghapusan akun akan secara otomatis membubarkan serikat. (Jika serikat dibubarkan, permintaan yang ditarik kembali tidak dapat memulihkan serikat). Jika Anda adalah anggota serikat, penghapusan akun akan secara otomatis mengeluarkan Anda dari serikat (Anda dapat membatalkan permintaan dalam 15 hari untuk memulihkan).",
    p6: "Jika Anda adalah ketua keluarga, Anda harus membubarkan atau keluar dari keluarga sebelum mengajukan penghapusan akun.",
    p7: "Jika Anda adalah anggota keluarga (bukan ketua), mengajukan penghapusan akun akan segera mengeluarkan Anda dari keluarga (penghapusan dalam periode banding 15 hari tidak dapat memulihkan keanggotaan keluarga).",
    p8: "Setelah pengajuan penghapusan, terdapat periode banding selama 15 hari. Masuk selama periode ini akan membatalkan penghapusan secara otomatis. Setelah periode banding berakhir, akun akan dihapus secara permanen dan tidak dapat dipulihkan. Jika akun perlu dipulihkan karena tindakan tidak sah atau kesalahan, silakan hubungi layanan pelanggan untuk banding. (WhatsApp Layanan Pelanggan: +62 81188011180, atau email: rainlive888@gmail.com).",
  },

  Proxy: {
    Hello: "Halo, ",
    Welcome: "Selamat Datang di Rain Chat!",
    Account: "Akun",
    Pleaseenter: "Silahkan masukkan",
    Password: "Kata sandi",
    Login: "Login",
    MyAgent: "Agen saya",
    Nickname: "Nama panggilan agensi",
    CoinBalance: "Saldo koin agensi",
    TransferRecord: "Riwayat transfer",
    Recharge: "Isi ulang",
    ExchangeProxyCoin: "Tukar koin agensi",
    TransferInformation: "Harap isi informasi transfer",
    Reset: "Atur ulang",
    RecipientID: "ID Penerima",
    RecipientNickname: "Nama panggilan penerima",
    TransferAmount: "Jumlah transfer",
    TotalTransferAmount: "Total",
    Transfer: "Transfer",
    KindReminder: "Peringatan",
    DoubleCheck: "Harap periksa kembali informasi sehingga tidak ada kesalahan",
    SelectAmount: "Pilih jumlah yang ingin diisi ulang",
    SelectMonth: "Pilih bulan",
    Username: "Nama pengguna",
    TransferTime: "Waktu transfer",
    AutoFill: "Isi Otomatis",
    Rechargeselection: "Isi ulang pemilihan",
    ProxyCurrency: "Koin Agen Tidak Cukup",
    PaymentAmount: "Jumlah pembayaran",
    PleaseSelectAmount: "Pilih jumlah yang ingin diisi ulang",
    GoldExchangeTitle: "Tukar Kacang Emas ke Koin Agen",
    GoldBalanceLabel: "Saldo Kacang Emas: ",
    InputGoldPlaceholder: "Masukkan kacang emas",
    AvailableProxyCoin: "Koin agen yang bisa didapat",
    GiftProxyCoin: "Bonus {amount} koin agen",
    GiftBonusPercent: "Bonus {bonus}%",
    Exchange: "Tukar",
    Tip: "Peringatan",
    ExchangeConfirmHtml:
      'Anda akan menggunakan <span class="green">{gold}</span> kacang emas untuk menukar <span class="green">{coin}</span><br/>koin agen, dengan bonus <span class="orange">{gift}</span> koin agen.',
    ExchangeSuccessTitle: "Penukaran berhasil",
    ExchangeSuccessText: "Koin agen telah masuk, mohon diperiksa.",
    ExchangeFail: "Penukaran gagal",
    RequestFail: "Permintaan gagal",
  },
  bd: {
    index: {
      guildCount: "Jumlah Persatuan",
      weekEstimatedIncome: "Pendapatan Mingguan",
      lastWeekIncome: "Pendapatan Mingguan",
      inviteCode: "Kod Jemputan",
      copySuccess: "Kod Jemputan berjaya disalin",
      searchPlaceholder: "Masukkan ID Persatuan",
      enterGuildId: "Sila masukkan ID Persatuan",
      searchGuild: "Cari Persatuan",
      lastWeek: "Minggu Sebelumnya",
      weekIncome: "Pendapatan Mingguan",
      myIncome: "Pendapatan Saya",
      effectiveLive: "Jumlah Siaran Langsung",
      bindDays: "Jumlah Hari",
      summary: "Ringkasan",
      guildName: "Nama Persatuan",
      guildId: "ID Persatuan",
      guildIncome: "Pendapatan Persatuan",
      effectiveLive: "Jumlah Siaran Langsung",
      myIncome: "Pendapatan Saya",
      date: "Tarikh",
      noData: "Tiada data tersedia",
      searching: "Mencari data pendapatan",
      showingSummary: "Tampilkan ringkasan data",
      loading: "Memuatkan data...",
      loadFailed: "Gagal memuatkan data",
      networkError: "Ralat jaringan, sila cuba lagi nanti",
    },
    incomeDetail: {
      title: "Butiran Pendapatan",
      lastWeekIncome: "Pendapatan Mingguan",
      totalIncome: "Pendapatan Total",
      guildId: "ID Persatuan",
      date: "Tarikh",
      thisWeek: "Minggu Ini",
      lastWeek: "Minggu Sebelumnya",
      beforeLastWeek: "Minggu Sebelum Minggu Sebelumnya",
      thisMonth: "Bulan Ini",
      lastMonth: "Bulan Sebelumnya",
      guildName: "Nama Persatuan",
      guildIncome: "Pendapatan Persatuan",
      search: "Cari",
      showSummary: "Tampilkan Ringkasan",
      noData: "Tiada data tersedia",
      searching: "Mencari data pendapatan",
      showingSummary: "Tampilkan ringkasan data",
    },
  },
  noble: {
    expireTime: "Tanggal kedaluwarsa",
    canReceive: " Dapat diklaim: {coin} koin emas",
    receive: "Terima Sekarang",
    received: "Sudah Terima",
    becomeNoble: "Jadikan Noble",
    totalCanGet: "Jumlah yang boleh dapatkan {price}{totalCoin} syiling",
    silver: "Perak",
    gold: "Emas",
    platinum: "Platinum",
    diamond: "Berlian",
    obsidian: "Obsidian",
    type: "Manfaat",
    levelReward: "Keterangan",
    dailyExCoin: "Ex-Coin",
    rechargeReward: "Top-up",
    gameSupport: "Game",
    exclusiveDecoration: "Pakaian",
    decoration: {
      profileCard: "Profil",
      bubble: "Bubble",
      vehicle: "Kendaraan",
      avatarFrame: "Bingkai Avatar",
      badge: "Lencana",
    },
    dailyFreeExCoin: "{amount} Ex-Coin Gratis Harian",
    monthlyRechargeBenefit:
      "{percent}% top-up bulanan sebagai dana keuntungan, dikirim bulan berikutnya.",
    monthlyGameConsumptionBenefit:
      "{percent}% pemakaian koin emas game bulanan, dikirim bulan berikutnya.",
    privileges: {
      getCoin: "Klaim koin",
      avatarFrame: "Bingkai Avatar",
      medal: "Lencana",
      vehicle: "kendaraan khusus",
      purchaseNotification: "Notifikasi pembelian",
      chatBubble: "Balon chat",
      colorfulNickname: "Efek visual mata",
      specialId: "ID Khas",
      mystery: "Rahsia",
      exclusiveService: "Perkhidmatan Eksklusif",
      title: "Manfaat",
      Effect: "Efek Masuk Ruang",
    },
    contactOperation: "Hubungi Operasi",
    receiveSuccess: "Terima syiling berjaya",
    level1Recharge: " Silver VIP / 30 hari",
    level2Recharge: "Gold VIP / 30 hari",
    level3Recharge: "Platinum VIP / 30 hari",
    level4Recharge: "Diamond VIP / 30 hari",
    level5Recharge: "Black VIP / 30 hari",
    vipCenterTitle: "Pusat VIP",
    expireTimeText: "Berlaku hingga",
    openVip: "Isi ulang untuk membuka",
    reachedLevel: "Level tercapai",
    stillNeedCoins: "Perlu {amount} koin lagi",
    stillNeedCoinsToKeepGrade:
      "Perlu {amount} koin lagi untuk mempertahankan level",
    stillNeedCoinsToActivate:
      "Perlu {amount} koin lagi untuk mengaktifkan {levelName}",
    keepGradeCompleted: "Pembaruan",
    keepGradeProgress: "Kemajuan Pemeliharaan Level: ",
    progress: "Kemajuan",
  },
  bonusActivity: {
    title: "Aktivitas Bonus Siaran Langsung",
    activityTime: "Periode Aktivitas: 7 Apr 00:00 - 4 Mei 23:59:59(UTC+8)",
    rewardRules: "Aturan Hadiah",
    reward: "Hadiah",
    totalReceived: "Total Diterima",
    bonus: "Bonus",
    claim: "Klaim",
    claimed: "Sudah Diklaim",
    notAchieved: "Belum Tercapai",
    duration: "Durasi (Jam)",
    target: "Target (Koin)",
    note: "Catatan: Setelah mencapai target, bonus dapat diklaim pada hari berikutnya",
    activityCalendar: "Kalender Aktivitas",
    april: "April",
    may: "Mei",
    claimSuccess: "Berhasil Diklaim",
  },
  bonusActivityRule: {
    activityDescription: "Deskripsi Aktivitas",
    descriptionContent:
      "Selain hadiah dasar, host akan menerima bonus tambahan dari Rain Live.",
    activityTime: "Periode Aktivitas",
    timeContent1: "7 April 2025 hingga 4 Mei 2025 (UTC+8)",
    timeContent2:
      "Pada pukul 0:00 (UTC+8) setiap hari, hadiah untuk hari berikutnya akan diaktifkan",
    claimMethod: "Metode Klaim",
    claimContent:
      "Ketika target tercapai pada hari ini, hadiah dapat diklaim secara manual pada hari berikutnya.",
    rewardTable: "Tabel Hadiah:",
    targetTurnover: "Target Omset",
    activityReward: "Hadiah Aktivitas",
  },
  inviteFriends: {
    invitationEventTitle: "Acara Undangan",
    inviteAndEarnRewards: "Undang & Dapat Hadiah",
    eventPeriod: "Periode Acara: 7 April 00:00 - 4 Mei 23:59:59 (UTC+8)",
    invitationRecord: "Riwayat Undangan",
    eventDetails: "Detail Acara",
    week1DateRange: "Minggu Pertama: 7 April - 13 April",
    totalInvitedExample: "Total Undangan",
    level1RewardText: "Lv.1 Undang 20 orang 20000 Koin",
    level2RewardText: "Lv.2 Undang 50 orang 50000 Koin",
    level3RewardText: "Lv.3 Undang 100 orang 100000 Koin",
    statusClaimed: "Sudah Diterima",
    actionClaim: "Terima",
    statusNotAchieved: "Belum Tercapai",
    topUpRewardsLabel: "Bonus Top-Up:",
    copyInvitationLink: "Salin Tautan Undangan",
    rewardNote:
      "Catatan: Saat pengguna yang diundang melakukan top-up, kamu akan mendapatkan 2% dari jumlah koin sebagai hadiah.",
    copySuccess: "Salin Berhasil",
    claimSuccessExample: "Berhasil Menerima 20000 Koin",
    userIDLabel: "User ID",
    userNameLabel: "Nama Pengguna",
    timeLabel: "Waktu",
    topUpLabel: "Top-Up",
    eventPurposeTitle: "【Tujuan Acara】",
    eventPurposeDesc:
      'Untuk berterima kasih kepada pengguna atas dukungan dan cintanya terhadap Rain Live, platform ini meluncurkan acara "Undang Teman & Dapatkan Banyak Hadiah". Kami mengundang Anda dan teman-teman untuk menikmati pengalaman live streaming yang seru!',
    eventDurationTitle: "【Periode Acara】",
    eventDateRange: "7 April 2025 – Mei 2025",
    eventCycleDesc:
      "Total 4 minggu, dengan hadiah baru dimulai setiap Senin pukul 00:00 (UTC+8).",
    rewardRulesTitle: "【Aturan Hadiah】",
    rewardRulesDesc1:
      "Selain hadiah dari acara ini, Anda juga tetap mendapatkan bonus undangan sebelumnya:",
    rewardRulesDesc2:
      "2% dari koin yang di-top-up oleh pengguna yang diundang akan diberikan sebagai hadiah tambahan kepada pengundang.",
    importantNotesTitle: "【Catatan Penting】",
    importantNotesDesc:
      "⚠️ Dilarang menggunakan akun palsu, pendaftaran bot, atau tindakan curang lainnya untuk mendapatkan hadiah. Jika terdeteksi, semua hadiah akan dicabut segera, dan fungsi akun mungkin akan dibatasi.",
  },
  bonusPoints: {
    activityTime: "Waktu Aktivitas",
    resetTime: "Reset setiap hari pukul 00:00 (UTC+8)",
    pointsReward: "Hadiah Poin",
    coinsReward: "Hadiah Koin",
    participationTimes: "Ikut {times} kali",
    points: "Poin",
    exchange: "Tukar",
    pointsMall: "Toko Poin",
    betSum: "Total Taruhan Saat Ini",
    note: "Catatan",
    rule1: "1.Poin diperoleh dengan menyelesaikan tugas harian.",
    rule2: "2.Hadiah di mall poin diganti tidak teratur.",
    rule3:
      "3.Setelah ditukar, poin tidak dapat dikembalikan. Tukar dengan hati-hati.",
    coins: "Koin",
    claim: "Ambil",
    claimed: "Terambil",
    notAchieved: "Belum Tercapai",
    reach: "Tercapai",
  },
  gameRanking: {
    notRanked: "Tidak Berperingkat",
    distanceToRank: "Masih kurang {points} poin untuk mencapai peringkat 50",
    distanceToBeforeRank:
      "Masih kurang {points} poin untuk mencapai peringkat {rankId}",
    rank1: "Anda sudah berada di peringkat pertama",
    today: "Hari Ini",
    yesterday: "Kemarin",
    ruleBtn: "Rule",
    rules: {
      pointsStats: {
        title: "Aturan Statistik Poin",
        conversion:
          "1. Standar Konversi Poin：1 koin sama dengan 1 poin dalam aktivitas, dan poin peserta akan dihitung langsung berdasarkan jumlah koin.",
        timeRange:
          "2. Rentang Waktu Statistik：Periode statistik poin harian adalah 00:00 hingga 23:59 (Zona Waktu UTC+8). Data koin yang melebihi periode waktu ini akan dimasukkan ke statistik hari berikutnya.",
      },
      ranking: {
        title: "Aturan Peringkat dan Hadiah",
        basis:
          "3. Basis Peringkat：Sistem akan melakukan peringkat secara descending berdasarkan total poin akhir peserta setiap hari (yaitu total jumlah koin hari itu) untuk menentukan peringkat harian.",
        rewards: "4. Pengaturan Hadiah：",
        reward1: "Peringkat 1: Hadiah 250.000 koin",
        reward2: "Peringkat 2: Hadiah 150.000 koin",
        reward3: "Peringkat 3: Hadiah 100.000 koin",
        reward4: "Peringkat 4: Hadiah 50.000 koin",
        reward5: "Peringkat 5: Hadiah 50.000 koin",
      },
      distribution: {
        title: "Aturan Pendistribusian Hadiah",
        description:
          "Hadiah yang sesuai dengan peringkat harian akan didistribusikan secara serentak pada hari berikutnya. Peserta dapat masuk ke halaman aktivitas atau akun pribadi pada hari berikutnya untuk memeriksa status penerimaan hadiah.",
      },
      pointsCalculation: {
        description:
          "Omzet Game minimal 5.000.000 diperlukan untuk memenuhi syarat mendapatkan hadiah acara.",
      },
      helpReward: {
        description:
          "Bantuan Hadiah: Jika syarat yang sesuai telah dipenuhi tetapi hadiah peringkat tidak ditebus, hadiah bantuan akan diperolehi.",
      },
      turnoverRewards: {
        title: "Aturan Hadiah Omzet",
        turnover: "Omzet",
        reward: "Hadiah",
        turnover1M: "1,000,000",
        reward10K: "10,000 Koin",
        turnover3M: "3,000,000",
        reward30K: "30,000 Koin",
        turnover5M: "5,000,000",
        reward50K: "50,000 Koin",
      },
      violation: {
        title: "Aturan Sanksi Pelanggaran",
        description:
          "Selama aktivitas berlangsung, dilarang keras bagi peserta menggunakan celah sistem, cheat, atau cara apa pun untuk mem 刷取 (men 刷取) poin (koin) secara tidak jujur. Jika ditemukan:",
        penalty1:
          "5. Peserta yang melanggar untuk pertama kalinya akan kehilangan hak untuk mendapatkan hadiah hari itu;",
        penalty2:
          "6. Peserta yang melanggar dengan 情节 (情节) yang parah atau berulang kali akan langsung dilarang mengikuti aktivitas ini dan aktivitas terkait berikutnya, dan hak partisipasi tidak akan dikembalikan.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Hari Ini",
    yesterday: "Kemarin",
    notRanked: "Tidak masuk peringkat",
    distanceToRank:
      "Butuh {points} kacang keberuntungan lagi untuk masuk 50 besar",
    distanceToBeforeRank:
      "Butuh {points} kacang keberuntungan lagi untuk mencapai peringkat {rankId}",
    rank1: "Anda sudah peringkat 1",
    rules: {
      activity: {
        title: "Deskripsi Aktivitas",
        description:
          "Menghitung pendapatan kacang keberuntungan harian streamer dan membuat peringkat berdasarkan pendapatan ini.",
      },
      ranking: {
        title: "Hadiah Peringkat",
        rank: "Peringkat",
        reward: "Hadiah Kacang",
        decoration: "Dekorasi",
        frameAndBubble: "Bingkai Avatar + Gelembung",
        frameOnly: "Bingkai Avatar",
        requirement:
          "Persyaratan minimum untuk hadiah peringkat: 150,000 pendapatan kacang keberuntungan.",
      },
      helpReward: {
        title: "Hadiah Dukungan",
        description:
          "Pengguna yang tidak menerima hadiah peringkat juga bisa mendapat hadiah target pendapatan kacang keberuntungan.",
        target: "Target",
        reward: "Hadiah",
      },
      distribution: {
        title: "Distribusi Hadiah",
        description: "Hadiah akan didistribusikan pada hari berikutnya.",
      },
      statistics: {
        title: "Deskripsi Statistik",
        description: "Statistik berdasarkan pendapatan kacang keberuntungan.",
      },
    },
  },

  // Aktivitas Red Envelope Rain
  redEnvelopeRain: {
    countdownTitle: "Hitung Mundur Ambil Koin",
    startNow: "Mulai Sekarang",
    rules: "Aturan",
    timeSlotPrize: "Hadiah Partisipasi Periode",
    winningDetails: "Detail Kemenangan",
    activityRules: "Aturan Kegiatan",
    congratulations: "Selamat Menang!",
    sorryNoWin: "Maaf, Anda tidak menang!",
    coin: "Koin",
    rulesContent: {
      rule1: "1.Waktu Kegiatan: 26 September ~ 15 Oktober",
      rule2:
        "2.Aturan Kegiatan: Sebelum membuka hongbao setiap kali, silakan kirim 3 kali pesan di ruang siaran langsung (live stream) untuk bisa menerima hongbao.",
      rule3:
        "3.Waktu Pengambilan Hongbao: Setiap hari dari pukul 20:00 hingga 00:40. Hongbao tersedia setiap 20 menit sekali.",
      rule4:
        "4.Kesempatan Partisipasi: Anda dapat berpartisipasi berulang kali pada jam yang berbeda.",
      rule5:
        "5.Pemberian Emas (Coin): Emas yang diambil akan langsung dikirim ke akun Anda.",
    },
    timeStatus: {
      inProgress: "Sedang Berlangsung",
      notStarted: "Belum Dimulai",
      finished: "Selesai",
    },
    chatRequirement:
      "Kirim 3 pesan di ruang siaran langsung untuk klaim, pesan saat ini: {count}",
  },

  // Aktivitas Guild
  guildActivity: {
    ruleBtn: "Rule",
    tabThis: "THIS",
    tabLast: "LAST",
    activityRules: "Aturan Kegiatan",
    rulesContent: {
      activityTime: "Waktu Kegiatan: Dimulai 29 September",
      rankingRewards: "Hadiah Peringkat",
      requirements: "Persyaratan",
      rewardDistribution: "Distribusi Hadiah",
      rewardList: {
        first: "Juara 1: 1.000.000 Kacang Emas",
        second: "Juara 2: 500.000 Kacang Emas",
        thirdToFifth: "Juara 3-5: 250.000 Kacang Emas",
        sixthToTenth: "Juara 6-10: 100.000 Kacang Emas",
        eleventhToTwentieth: "Juara 11-20: 50.000 Kacang Emas",
      },
      requirementText:
        "Host guild harus menyelesaikan minimal 30 siaran langsung per minggu. Setiap host yang siaran lebih dari 2 jam per hari dihitung sebagai satu sesi",
      distributionText: "Hadiah akan didistribusikan pada minggu kedua",
    },
  },

  // Peringkat Daya Tarik/Konsumsi
  charmRanking: {
    charmRanking: "Peringkat Daya Tarik",
    consumptionRanking: "Peringkat Konsumsi",
    dailyRanking: "Peringkat Harian",
    weeklyRanking: "Peringkat Mingguan",
    userNickname: "Nama Pengguna",
    distanceToPrevious: "Jarak ke Sebelumnya",
    noRankingData: "Tidak Ada Data Peringkat",
    requestFailed: "Permintaan Gagal",
  },

  // Aktivitas Undangan
  inviteActivity: {
    title: "Undang 3 Orang Pasti Dapat Hadiah",
    rule: "Aturan",
    alreadyJoined: "Sudah Bergabung",
    inviteImmediately: "Undang segera",
    callNumber: "Undang",
    myRewards: "Hadiahku",
    claim: "Ambil",
    claimed: "Sudah Diambil",
    people: "Orang",
    inviteFriends: "Undang teman",
    processTitle: "Proses Undangan:",
    step1: "1. Kirim link ke teman",
    step2: "2. Teman unduh dan daftar",
    step3: "3. Dapatkan koin gratis",
    rulesTitle: "Aturan Undangan",
    rulesContent: {
      rule1: "Saat mengundang 3 orang, dapat mengambil 16666 kacang emas",
      rule2: "Saat mengundang 25 orang, dapat mengambil lagi 36666 kacang emas",
      rule3:
        "Saat mengundang 100 orang, dapat mengambil lagi 88888 kacang emas. Total dapat mengambil 142220 kacang emas.",
      rule4: "Hadiah diambil secara manual di halaman aktivitas.",
      rule5:
        "Dilarang keras melakukan penipuan jumlah orang dengan sengaja, jika ditemukan akan dilakukan pemblokiran akun",
    },
    close: "Tutup",
    inviteFeatureComingSoon: "Fitur undangan akan segera tersedia",
    rewardReceived: "Berhasil menerima {amount} koin!",
  },

  // Halaman Hadiah Koin Emas
  giftGoldCoins: {
    maxGiftableCoins: "Saldo koin emas",
    giftAmount: "Jumlah Koin Emas Hadiah",
    customAmount: "Jumlah Koin Emas Hadiah Kustom",
    enterAmount: "Masukkan jumlah",
    quantity: "Kuantitas",
    giftToOtherAccounts: "Hadiahkan ke Akun Lain",
    exceedMaxAmount:
      "Jumlah tidak boleh melebihi maksimum yang dapat dihadiahkan",
    amountSet: "Jumlah berhasil ditetapkan",
    invalidAmount: "Silakan masukkan jumlah yang valid",
    selectValidAmount: "Silakan pilih jumlah yang valid",
    confirmTitle: "Konfirmasi Hadiah",
    confirmMessage: "Apakah Anda yakin ingin menghadiahkan {amount} koin?",
    giftSuccess: "Hadiah berhasil",
    giftId: "ID Hadiah",
    enterGiftId: "Masukkan ID",
    pleaseEnterGiftId: "Silakan masukkan ID hadiah",
    giftCompleted: "Hadiah berhasil!",
    giftedToId: "Dihadiahkan ke ID",
    networkError: "Kesalahan jaringan, silakan coba lagi nanti",
    confirm: "Konfirmasi",
  },

  // Toko Dekorasi
  shop: {
    headerTitle: "Dekorasi Pribadi",
    back: "Kembali",
    shoppingBag: "Tas Belanja",
    loading: "Memuat...",
    noProducts: "Tidak Ada Produk",
    unnamedProduct: "Produk Tanpa Nama",
    day: "Hari",
    myCoins: "Koin Saya",
    exchangeNow: "Tukar Sekarang",
    notSelected: "Belum Dipilih",
    loginExpired: "Login kedaluwarsa, silakan login lagi",
    categoryNotExists: "Kategori tidak ada",
    loadFailed: "Gagal Memuat",
    loadFailedRetry: "Gagal memuat, silakan coba lagi",
    pleaseSelectProduct: "Silakan pilih produk terlebih dahulu",
    productNotExists: "Produk tidak ada",
    insufficientCoins: "Koin tidak cukup, butuh {amount} koin",
    exchangeSuccess: "Tukar Berhasil",
    exchangeFailed: "Tukar Gagal",
    categories: {
      hot: "Populer",
      avatarFrame: "Bingkai Avatar",
      entryEffect: "Efek Masuk",
      chatBubble: "Gelembung Chat",
      mount: "Kendaraan",
    },
    recharge: "Isi Ulang >",
    validityPeriod: "Masa Berlaku:",
    myCoinsLabel: "Koin Saya:",
  },
  myDecoration: {
    headerTitle: "Dekorasi Saya",
    back: "Kembali",
    noWearingDecoration: "Tidak ada dekorasi yang dipilih",
    loading: "Memuat...",
    noDecoration: "Tidak Ada Dekorasi",
    unnamedDecoration: "Dekorasi Tanpa Nama",
    permanent: "Permanen",
    wearing: "Sedang Dipakai",
    pleaseSelectDecoration: "Silakan Pilih Dekorasi",
    removeDecoration: "Lepas Dekorasi",
    wearNow: "Pakai Sekarang",
    pleaseSelectDecorationFirst: "Silakan pilih dekorasi terlebih dahulu",
    decorationNotExists: "Dekorasi tidak ada",
    loginExpired: "Login kedaluwarsa, silakan login lagi",
    loadFailed: "Gagal Memuat",
    loadFailedRetry: "Gagal memuat, silakan coba lagi",
    wearSuccess: "Pakai Berhasil",
    wearFailed: "Pakai Gagal",
    previewAnimation: "Pratinjau",
    categories: {
      hot: "Populer",
      avatarFrame: "Bingkai Avatar",
      entryEffect: "Efek Masuk",
      chatBubble: "Gelembung Chat",
      mount: "Kendaraan",
    },
  },
  // Aktivitas Natal/Bintang Keberuntungan
  christmasActivity: {
    dailyLuckyStar: "Bintang Keberuntungan Harian",
    weeklyLuckyStar: "Bintang Keberuntungan Mingguan",
    startTime: "Waktu mulai:",
    obtainedCount: "Jumlah yang diperoleh",
    moreChance: "Semakin banyak, semakin besar kesempatan",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "Riwayat",
    myRecord: "Riwayat Saya",
    noRecord: "Tidak ada riwayat",
    loading: "Memuat...",
    noMore: "Tidak ada lagi",
    coin: "Koin",
    goldCoin: "Kacang Emas",
    unit: "buah",
    notWon: "Tidak menang",
    conditionNotMet: "Kondisi tidak terpenuhi",
    claimSuccess: "Klaim berhasil",
    getRecordFailed: "Gagal mendapatkan riwayat",
    rules: {
      title: "Aturan Aktivitas",
      rule1: "Bintang Keberuntungan Harian",
      rule2:
        "Event Bintang Keberuntungan Harian, semua pengguna dapat ikut serta",
      rule3:
        "Saat memberikan gift yang dibentukan kepada hat, jumlah gilt alan baru. Jika jumlah gift yang diberikan sudah memenuhi syarat, mukabisa kutuan pembukaan red pacchert. Setiap uncen akan ada pengguna beruntung yang mendapatkan hadiah koin",
      rule4: "Semakin banyak gift yang diberikan, peluang untuk menang",
      rule5: "Bintang Keberuntungan Mingguan",
      rule6:
        "Event Bintang Keberuntungan Mingguan, semua hoat dapat berpartie роз",
      rule7:
        "Sant menerima gift yang ditentukan dari pengguna, Jumlah gift akan terakumulasi. Jika Jumiah gift yang diterima sudah mencukupi, host dispar kur membuka red packet Bintang Keberuntungan Mingguan. Setiap pembukaan akan ada host beruntung yang mendapatkan hadish.",
      rule8: "Semakin banyak Jumrah gift yong dito makin poluang untuk menang.",
      rule9: "Keterangan lainnya",
      rule10: "merupakan prog",
      rule11: "Jumlah gift hanya dapat saat memberlian kepada",
      rule12:
        "Dilarang keras memanfaatkan celah atau bug untuk mendapatkan hadiah",
      rule13:
        "Hadiah di setiap periode waktu akan dibagikan secara otomatis. Riwayat hadiah dapat dicek untuk mengetahui hasil kemenangan",
    },
  },
  // Aktivitas Peringkat Poin Bintang Keberuntungan
  fortuneStarActivity: {
    points: "Poin",
    pointsRanking: "Peringkat Poin",
    currentRoundPoints: "Poin Ronde Ini",
    lastRoundPoints: "Poin Ronde Terakhir",
    defaultUserName: "Nama Pengguna",
    noData: "Tidak Ada Data",
    activityRules: "Aturan",
    historyRecord: "Riwayat",
    earnedPoints: "Poin yang Diperoleh",
    participated: "Telah Berpartisipasi",
    notParticipated: "Tidak Terpenuhi",
    myRecord: "Riwayat Saya",
    userId: "ID",
    userNickname: "Nama Pengguna",
    sessionTime: "Waktu Sesi",
    winningStatus: "Status Kemenangan",
    won: "Menang",
    notWon: "Tidak Menang",
    rules: {
      rule1:
        "Selama acara, pengguna dapat memperoleh poin dengan mengirim hadiah yang ditentukan",
      rule2:
        "Poin terakumulasi secara real-time, periksa peringkat poin saat ini",
      rule3:
        "Setelah acara berakhir, pengguna yang berada di peringkat teratas akan menerima hadiah yang murah hati",
      rule4:
        "Menggunakan cara curang apa pun untuk memperoleh poin dilarang keras, pelanggar akan dibatalkan kelayakannya",
      rule5: "Platform mempertahankan hak interpretasi akhir",
    },
  },

  // Aktivitas Kotak Misteri
  blindBox: {
    title: "Penjelasan Cara Bermain",
    ruleTitle: "Penjelasan Cara Bermain",
    rule1:
      "Setiap {price} koin dapat membuka satu kali {text}. Setelah dibuka, kamu akan mendapatkan hadiah yang berbeda-beda, dan hadiah tersebut akan otomatis masuk ke dalam tas (backpack).",
    rule2:
      "Hadiah yang diperoleh dapat dikirimkan kepada streamer yang ingin kamu beri hadiah melalui tas. Pihak penerima akan mendapatkan keuntungan/koin yang sesuai dari hadiah tersebut.",
    rewardTip: "Tips Hadiah",
    probabilityDesc: "Probabilitas spesifik adalah sebagai berikut:",
    prize: "Hadiah",
    probability: "Probabilitas",
    value: "Nilai",
  },

  taskHub: {
    tabCenter: "Task Center",
    tabAnchor: "Host Tasks",
    signTitle: "7-day Check-in",
    signStreakBefore: "Consecutive check-in ",
    signStreakAfter: " days",
    signBtn: "Check in",
    signBtnDone: "Checked in",
    signPeriod: "This period: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "Avatar frame",
    activeTasks: "User activity tasks",
    timeLeft: "Time left: {t}",
    claimable: "Claim",
    inProgress: "In progress",
    rewardGain: "Earn {n} EX coins",
    taskWatchLive: "Watch live for 30 minutes",
    taskFollowHosts: "Follow 3 hosts",
    taskSpeakRooms: "Speak 3 times in different rooms",
    taskGiftCoins: "Spend 100 coins on gifts",
    taskGameCoins: "Spend 100 coins on games",
    taskRechargeToday: "Recharge once today",
    unitMinutes: " min",
    unitHosts: " hosts",
    unitTimes: " times",
    unitCoins: " coins",
    unitDays: " days",
    toastSigned: "Checked in",
    toastClaimed: "Claimed",
    claimSuccessTitle: "Claim Successful",
    claimSuccessOk: "Got it",
    toastInProgress: "Task in progress",
    toastLoadFail: "Failed to load",
    claimed: "Completed",
    toastRefreshed: "Refreshed",
    anchorActivity: "Activity",
    weekDurationTitle: "Weekly duration",
    activityPeriod: "Activity period",
    weekLiveDuration: "Live duration this week",
    weekRank: "Weekly rank",
    claimableReward: "Claimable reward",
    effectExtraTitle: "Special effect bonus",
    effectBeansToday: "Effect beans received today",
    rewardDate: "Reward date {date}",
    claimableAmount: "Claimable",
    claimNow: "Claim now",
    claimedToday: "Claimed today:",
    effectNote: "Note: claim today's rewards before 1:00 (UTC+8) the next day.",
    todayData: "Today Data",
    todayLiveDuration: "Today's live duration",
    liveHintShort: "{remain} left",
    needMoreBeans: "{n} more needed",
    toastNoClaimable: "No reward available to claim",
    toastClaimPending: "Claim API pending integration",
    luckyBeans: "Lucky beans",
    nextDayLucky: "Next-day lucky reward",
    upgradeBeansTitle: "Upgrade to claim beans",
    upgradeReward: "Upgrade reward",
    weekData: "Week Data",
    totalLiveDuration: "Total live duration",
    validDays: "Valid days",
    weekLuckyReward: "Weekly lucky reward",
    dayDataTitle: "Today Data",
    monthDataTitle: "Month Data",
    weekDataTitle: "Week Data",
    monthLiveDuration: "Monthly live duration",
    weekLiveDuration: "Weekly live duration",
    specialBeans: "Special beans",
    totalBeans: "Total beans",
  },

  pcOfficial: {
    navHome: "Beranda",
    navLive: "Siaran Langsung",
    navGameHall: "Lobby Game",
    received: "menerima",
    heroTagline: "Platform Hiburan Web4 Terkemuka Dunia",
    heroTaglineSub:
      "Interaksi real-time 24/7 dengan host terbaik dan pengalaman game blockchain premium. Didukung teknologi terdesentralisasi untuk hadiah instan dan permainan yang adil.",
    downloadNow: "Unduh Sekarang",
    giftCoin: "Koin EX",
    giftAvatarFrame: "Frame Avatar",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Rekomendasi Host Populer",
    recommendSub:
      "Berinteraksi real-time dengan ribuan host terbaik dan nikmati daya tarik game P2E",
    hotGamingTitle: "Game Populer",
    hotGamingSub:
      "Pemain nyata, peringkat nyata. Apakah kamu legenda berikutnya?",
    casinoTitle: "Casino",
    casinoDesc1: "Bermain bersama dealer langsung untuk Baccarat,",
    casinoDesc2: "Roulette, dan Blackjack dalam HD",
    slotsTitle: "Slots",
    slotsDesc: "Mainkan ratusan slot premium dengan RTP 98.5%",
    gamingTitle: "Gaming",
    gamingDesc: "Lebih dari sekadar putaran, nikmati game skill multiplayer",
    whyTitle: "Mengapa Memilih Rain Live",
    whyItem1Title: "Adil & Transparan",
    whyItem1Desc: "RNG terverifikasi untuk memastikan permainan yang adil",
    whyItem2Title: "Pembayaran Instan",
    whyItem2Desc: "Penarikan cepat dengan penyelesaian instan",
    whyItem3Title: "Anonim & Privat",
    whyItem3Desc: "100% privat tanpa memerlukan data pribadi",
    whyItem4Title: "Terdesentralisasi",
    whyItem4Desc: "Game on-chain yang aman dan transparan",
    terms: "Ketentuan Layanan",
    privacy: "Kebijakan Privasi",
    navRecharge: "Isi ulang",
    rechargeAccountTitle: "Akun isi ulang",
    idLogin: "Login ID",
    accountIdLabel: "ID akun:",
    accountIdPlaceholder: "Masukkan ID akun",
    confirm: "Konfirmasi",
    defaultUserName: "Nama pengguna",
    userIdWithValue: "ID:{id}",
    switchAccount: "Ganti akun",
    rechargeQuantityTitle: "Jumlah isi ulang",
    goToPay: "Lanjut bayar",
    topUpAmountTitle: "Jumlah top-up",
    pay: "Bayar",
    channelDefault: "Saluran pembayaran",
    toastInvalidAccountId: "Masukkan ID akun yang valid",
    toastNoTokenAfterLogin: "Login berhasil tetapi token tidak diterima",
    toastLoginFailed: "Login gagal",
    toastCoinPackagesFailed: "Gagal memuat daftar paket koin",
    toastPayChannelsFailed: "Gagal memuat saluran pembayaran",
    toastOrderParamsMissing: "Parameter pesanan kurang, tidak dapat bayar",
    toastNoPayUrl: "URL pembayaran tidak ditemukan",
    toastCreateOrderFailed: "Gagal membuat pesanan pembayaran",
    rainLiveRecharge: "Rain Live Isi ulang",
    selectCountryTitle: "Pilih negara / wilayah",
    selectChannelTitle: "Pilih metode pembayaran",
    rechargeLoading: "Memuat...",
    rechargePackagesEmpty: "Belum ada paket isi ulang",
    rechargeLoginHint: "Silakan masuk dengan ID terlebih dahulu",
  },

  liveDuration: {
    tabthisWeek: "This  Week",
    tablastWeek: " Last Week",
    eventTime: "Waktu Acara: {time}",
    rewardCoin: "Koin hadiah",
    liveHours: "Durasi siaran langsung",
    myRank: "Peringkat Saya",
    zeroHours: "0 jam",
    hoursOnly: "{hours} jam",
    minutesOnly: "{minutes} menit",
    hoursMinutes: "{hours} jam {minutes} menit",
  },

  // Halaman pembayaran pesanan top up USDT
  topUpUsdt: {
    orderNo: "No. Pesanan",
    copy: "Salin",
    copyOrderNo: "Salin nomor pesanan",
    copyAddress: "Salin alamat penerima",
    productName: "Koin Emas RainChat",
    quantityUnit: "× {count}",
    orderAmount: "Jumlah pesanan",
    scanToPay: "Pindai untuk bayar",
    scanTip: "Pindai kode QR dengan aplikasi dompet untuk bayar",
    qrAreaAlt: "Area kode QR pembayaran",
    qrCodeAlt: "Kode QR pembayaran",
    receivingAddress: "Alamat penerima",
    validityPrefix: "Berlaku",
    validityMinutes: "{minutes} mnt",
    validitySuffix: ", segera bayar",
    orderNoCopied: "Nomor pesanan disalin",
    addressCopied: "Alamat penerima disalin",
    nothingToCopy: "Tidak ada yang bisa disalin",
    copyFailed: "Gagal menyalin, silakan salin secara manual",
    promptTitle: "提示",
    rechargePrompt: "Jika sudah top up, silakan ketuk Selesaikan Top Up",
    cancel: "Batal",
    completeRecharge: "Selesaikan Top Up",
    rechargeCompleted: "✔ Top up selesai",
    rechargeCompletedText: "Top up selesai",
    rechargePending:
      "Pembayaran belum diterima. Mungkin ada keterlambatan. Koin akan ditambahkan otomatis setelah pembayaran diterima.",
    gotIt: "Mengerti",
  },

  rainChatOfficial: {
    appNotDetected: "Aplikasi tidak terdeteksi. Silakan unduh.",
  },

  // Aktivitas Roda Keberuntungan Koin Pengalaman
  luckyTurntable: {
    draw: "Undian",
    drawing: "Sedang undi",
    task: "Tugas",
    recharge: "Isi ulang",
    historyRecord: "Riwayat",
    balanceLabel: "Saldo Koin Pengalaman: ",
    exGradeTip:
      "Level Ex Lv.{grade} · Membutuhkan Lv.{level} untuk berpartisipasi",
    got: "dapat",
    defaultNotice: "Nama Pengguna {got} Koin Pengalaman",
    insufficientBalance: "Saldo tidak cukup",
    exGradeNotMet: "Level Ex belum tercapai",
    configLoadFailed: "Gagal memuat konfigurasi, coba lagi nanti",
    recordLoadFailed: "Gagal memuat riwayat, coba lagi nanti",
    drawResultError: "Hasil undian tidak normal, coba lagi nanti",
    drawFailed: "Undian gagal, coba lagi nanti",
    winTitle: "Selamat! Anda dapat",
    winConfirm: "Mengerti",
    loading: "Memuat...",
    noRecord: "Belum ada riwayat",
    noMore: "Tidak ada lagi",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "Undang Aktif",
    tabWelfare: "Bonus 7 Hari",
    tabMic: "Hadiah Naik Mic",
    inviteTitle: "Hadiah undang pengguna aktif",
    yesterdayData: "Data kemarin",
    yesterdayActive: "Jumlah aktif kemarin",
    goldBean: "Kacang emas",
    todayDataRealtime: "Data hari ini (real-time)",
    todayActive: "Jumlah aktif hari ini",
    peopleUnit: "orang",
    estimateReward: "Perkiraan hadiah",
    claimTomorrowTip: "Bisa diklaim pukul 10:00 besok",
    claimAt10: "Bisa diklaim jam 10",
    claimYesterday: "Klaim hadiah kemarin",
    claimed: "Sudah diklaim",
    noReward: "Belum ada hadiah",
    viewDetail: "Lihat detail",
    welfareTitle: "Bonus 7 hari host baru",
    personalNewHost: "Host baru pribadi",
    rule: "Aturan",
    welfareRemain: "Sisa waktu bonus",
    dayUnit: "hari",
    minuteUnit: "menit",
    day1: "Hari ke-1",
    day7: "Hari ke-7",
    todayData: "Data hari ini",
    todayMicDuration: "Durasi naik mic hari ini",
    claimableBean: "Kacang emas bisa diklaim",
    claimReward: "Klaim hadiah",
    claimTodayReward: "Klaim hadiah hari ini",
    todayCanClaim: "Hari ini masih bisa klaim {amount}",
    needMic60: "Naik mic 60 menit hari ini untuk klaim",
    needMic120: "Naik mic 120 menit hari ini untuk klaim",
    todayClaimedAll: "Hadiah hari ini sudah habis",
    becomeAnchor: "Jadi host untuk klaim hadiah",
    totalClaimed: "Total kacang emas diklaim",
    welfareRulesTitle: "Aturan Bonus 7 Hari",
    welfareCondTitle: "1. Syarat partisipasi:",
    welfareCond1: "a. Pengguna baru dalam 7 hari sejak pendaftaran",
    welfareCond2: "b. Menyelesaikan verifikasi Host",
    welfareCond3: "c. Belum bergabung dengan Agency",
    welfareRewardTitle: "2. Penjelasan hadiah",
    welfareReward1:
      "a. Naik mic dan membuka mic setiap hari akan mengakumulasi durasi.",
    welfareReward2: "b. Setiap 1 jam, Anda dapat mengklaim 5.000 Gold Beans.",
    welfareReward3:
      "c. Maksimal 2 jam dan 10.000 Gold Beans dapat diklaim per hari.",
    welfareReward4: "d. Maksimal dapat mengklaim hadiah 70.000 Gold Beans.",
    welfareNoteTitle: "3. Catatan penting",
    welfareNote1: "a. Hadiah diklaim secara manual setiap hari",
    welfareNote2:
      "b. Jika waktu pendaftaran melebihi 7 hari, Anda tidak dapat mengklaim lagi.",
    welfareNote3: "c. Data diperbarui setiap 10-15 menit",
    welfareNote4:
      "d. Jika ditemukan penggunaan cara tidak adil untuk mengumpulkan hadiah, akun akan diblokir.",
    micRulesTitle: "Aturan Hadiah Naik Mic",
    micCondTitle: "1. Syarat partisipasi:",
    micCond1: "a. Menyelesaikan verifikasi Host",
    micCond2: "b. Belum bergabung dengan Agency.",
    micRewardTitle: "2. Hadiah",
    micGradeLevel: "Level",
    micGradeIncome: "Pendapatan Gold Beans 7 Hari",
    micGradeHourly: "Upah per jam (Gold Beans/j)",
    micGradeDaily: "Batas harian",
    micGradeBeans: "{beans} Gold Beans ({usd})",
    micGradeDailyLimit: "2 jam",
    micExplainTitle: "3. Penjelasan",
    micExplain1:
      "a. RainChat akan menghitung level Anda berdasarkan pendapatan Gold Beans 7 hari terakhir (hari ini + 6 hari sebelumnya)",
    micExplain2: "b. Data diperbarui setiap 10-15 menit.",
    micExplain3:
      "c. Berdasarkan level saat ini, Anda dapat mengklaim hadiah per jam Gold Beans yang sesuai dengan level tersebut.",
    micExplain4:
      "d. Hadiah diklaim secara manual dan akan masuk ke akun secara real-time setelah diklaim.",
    micExplain5:
      "e. Jika tidak diklaim pada hari yang sama, hadiah akan kedaluwarsa.",
    micExplain6: "f. Per hari dapat mengklaim hadiah per jam maksimal 2 jam.",
    micExplain7:
      "g. Saat pendapatan Gold Beans 7 hari terakhir melebihi batas SS. Setiap tambahan 700.000 Gold Beans, upah per jam bertambah 20.000.",
    micExplainExample: "Contoh: 7.700.000 Gold Beans, upah per jam 220.000.",
    micExplain8:
      'h. Saat menikmati "Bonus 7 Hari", hadiah per jam "Level I" tidak tersedia. Setelah "Bonus 7 Hari" berakhir, dapat diklaim secara normal.',
    micExplain9:
      "i. Jika ditemukan penggunaan cara tidak adil untuk mengumpulkan hadiah, akun akan diblokir.",
    nextRefresh: "Refresh berikutnya",
    recent7Days: "7 hari terbaru",
    micRangeTip: "Hari ini + 6 hari sebelumnya\nPerlu menjadi host",
    totalIncome: "Total pendapatan",
    upgradeDesc: "Kurang {remain} untuk upgrade, bonus bertambah {bonus}",
    ssBonusDesc: "Setiap tambahan 700K Gold Beans, bonus bertambah 20K Gold Beans.",
    completeAllTask: "Selesaikan semua tugas untuk mendapatkan",
    claim: "Klaim",
    grantSuccess: "Hadiah berhasil dikirim",
    thisTimeGot: "Kali ini mendapatkan",
    grantedToAccount: "Hadiah sudah masuk ke akun Anda",
    gotIt: "Mengerti",
    claimFail: "Klaim gagal, coba lagi nanti",
    micTaskName: "Live/on-mic {minutes} menit hari ini",
  },
  guildApply: {
    "title": "Permohonan guild",
    "pendingCount": "{count} Menunggu",
    "autoApproveTip": ">7 hari otomatis disetujui. Tinjau segera",
    "joinRequest": "({rainId}) ingin bergabung",
    "daysRemaining": "Sisa {days} hari",
    "appliedWithinOneDay": "Diajukan dalam 1 hari",
    "appliedDaysAgo": "{days} hari lalu",
    "boundDays": "Terikat: {days} hari",
    "incomeTier": "Tier pendapatan: {level}",
    "applyToGuild": "Ajukan ke guild",
    "reject": "Tolak",
    "approve": "Setujui",
    "noPendingRequests": "Tidak ada permintaan",
    "approved": "Disetujui",
    "rejected": "Ditolak",
    "approvalConfirmTitle": "Pemberitahuan",
    "approvalConfirmMessage": "Setelah disetujui, pengguna akan bergabung dengan guild lain dan tidak lagi memberikan komisi pendapatan kepada Anda.",
    "back": "Kembali",
    "pendingList": "Permohonan tertunda",
    "noToken": "Token login tidak ditemukan",
    "listLoadFailed": "Gagal memuat daftar permohonan",
    "listLoadFailedRetry": "Gagal memuat daftar permohonan, coba lagi nanti",
    "operationFailedRetry": "Operasi gagal, coba lagi nanti"
  },
  inviteFriendsNew: {
    "inviteRanking": "Peringkat undangan",
    "messages": "Pesan",
    "totalRewards": "Total hadiah undangan",
    "earnings": "Pendapatan",
    "totalValue": "Total nilai",
    "viewDetails": "Lihat detail",
    "inviteStats": "Statistik undangan",
    "totalInvites": "Total",
    "todayInvites": "Hari ini",
    "details": "Detail",
    "inviteFriends": "Ajak teman",
    "copyLink": "Salin tautan",
    "close": "Tutup",
    "saveImage": "Simpan gambar",
    "inviteModal": "Popup ajak teman",
    "rightTools": "Pintasan halaman",
    "noToken": "Token login tidak ditemukan",
    "rewardsLoadFailed": "Gagal memuat pendapatan undangan",
    "rewardsLoadFailedRetry": "Gagal memuat pendapatan undangan, coba lagi nanti",
    "inviteInfoLoadFailed": "Gagal memuat info undangan",
    "inviteInfoLoadFailedRetry": "Gagal memuat info undangan, coba lagi nanti",
    "linkNotReady": "Tautan undangan belum siap",
    "linkCopied": "Tautan undangan disalin",
    "copyFailedRetry": "Gagal menyalin, coba lagi nanti",
    "saveFailedRetry": "Gagal menyimpan gambar, coba lagi nanti"
  },
  inviteRanking: {
    "title": "Peringkat",
    "earningsRank": "Peringkat pendapatan",
    "inviteRank": "Peringkat undangan",
    "day": "Hari",
    "week": "Minggu",
    "total": "Total",
    "people": "Orang",
    "noToken": "Token login tidak ditemukan",
    "loadFailed": "Gagal memuat peringkat",
    "loadFailedRetry": "Gagal memuat peringkat, coba lagi nanti"
  },
  inviterInformation: {
    "title": "Undangan saya",
    "earnings": "Pendapatan",
    "members": "Anggota",
    "filter": "Filter:",
    "earningsTrend": "Tren pendapatan",
    "dailyInvites": "Undangan harian",
    "verifiedHost": "Host terverifikasi",
    "inGuild": "Sudah masuk guild",
    "contact": "Hubungi",
    "level1Earnings": "Pendapatan level 1",
    "level2Earnings": "Pendapatan level 2",
    "totalUsd": "Total (USD)",
    "loading": "Memuat...",
    "noMore": "Tidak ada lagi",
    "noData": "Tidak ada data",
    "back": "Kembali",
    "tabTypes": "Jenis info pengundang",
    "dateFilter": "Filter tanggal",
    "noToken": "Token login tidak ditemukan",
    "trendLoadFailed": "Gagal memuat data tren",
    "trendLoadFailedRetry": "Gagal memuat data tren, coba lagi nanti",
    "listLoadFailed": "Gagal memuat daftar pengundang",
    "listLoadFailedRetry": "Gagal memuat daftar pengundang, coba lagi nanti"
  },
  rewardSource: {
    "title": "Detail hadiah",
    "pleaseSelect": "Pilih",
    "activityEarnings": "Aktif",
    "rechargeEarnings": "Top Up",
    "gameCommission": "Game",
    "incomeCommission": "Pendapatan",
    "back": "Kembali"
  },
  rewardSourceRule: {
    back: "Kembali",
    active: {
      title: "Aturan Undangan",
      bindTitle: "Cara Mengikat Teman sebagai Pengguna Undangan",
      bindSteps: ["Langkah 1: Pada halaman utama program undangan, ketuk tombol Undang di bagian bawah, lalu simpan gambar atau salin tautan undangan pribadi Anda.", "Langkah 2: Kirim gambar yang telah disimpan atau tautan undangan pribadi tersebut kepada teman Anda.", "Langkah 3: Teman Anda mengunduh aplikasi dan mendaftar melalui kode QR pada gambar atau melalui tautan undangan pribadi. Setelah pendaftaran selesai, hubungan undangan akan terikat."],
      questionTitle: "Tanya: Mengapa hubungan undangan tidak dapat terikat?",
      answer: "Jawab: Setiap perangkat ponsel hanya dapat memiliki satu akun yang terikat dalam hubungan undangan. Teman Anda mungkin sudah pernah terikat sebelumnya.",
      userTitle: "Aturan Pengguna Aktif",
      userIntro: "Teman yang terikat dengan Anda dapat menambah jumlah pengguna aktif Anda dengan menyelesaikan tugas aktivitas harian.",
      tasks: ["Tugas 1: Naik mic dan menyalakan mikrofon selama 2 jam.", "Tugas 2: Total bet di Game mencapai 1.000 Koin.", "Pengguna wajib menyelesaikan verifikasi akun.", "Menyelesaikan salah satu tugas di atas akan memberikan 1 pengguna aktif yang valid kepada Anda.", "Setiap teman hanya dapat dihitung sebagai 1 pengguna aktif yang valid per hari."],
      userNotes: ["Untuk setiap teman yang terikat, masa perhitungan dimulai sejak pendaftaran. Hanya 7 hari pertama yang dapat memberikan jumlah pengguna aktif yang valid kepada Anda.", "Setiap teman yang terikat dapat memberikan maksimal 7 kali jumlah pengguna aktif yang valid."],
      rewardTitle: "Reward Pengguna Aktif",
      rewardIntro: "Jika jumlah pengguna aktif yang valid pada hari tersebut mencapai target tertentu, Anda dapat memperoleh reward Bean.",
      rewardTableIntro: "Reward sebagai berikut.",
      rewardTableLabel: "Tabel reward pengguna aktif",
      rewardHeaders: ["Pengguna Aktif Harian", "Reward Bean", "USD"],
      rewardNotes: ["Reward maksimum per hari bernilai hingga USD 70.", "Reward untuk hari tersebut dapat diklaim secara manual mulai pukul 10.00 pada hari berikutnya.", "Lokasi klaim: melalui tab Live atau tombol mengambang “Reward” di dalam ruang Live.", "Setelah reward tersedia, reward harus diklaim pada hari yang sama. Jika tidak diklaim, reward akan kedaluwarsa. Harap segera melakukan klaim jika Anda memiliki reward."],
      noticeTitle: "Hal yang Perlu Diperhatikan",
      notices: ["Setiap perangkat ponsel hanya dapat memiliki satu hubungan undangan yang terikat.", "Teman yang terikat wajib menyelesaikan verifikasi agar dapat dihitung sebagai pengguna aktif Anda.", "Daftar hanya menampilkan pengguna yang mendaftar dalam 7 hari terakhir.", "Jika ditemukan penggunaan cara yang tidak sah untuk mengikat akun atau memanipulasi jumlah pengguna, platform tidak akan menyalurkan reward. Untuk pelanggaran serius, akun dapat diblokir atau dikenai tindakan lain sesuai ketentuan platform."]
    },
    game: {
      title: "Aturan Komisi Game",
      levelTitle: "Sistem Level Komisi Game",
      levelText: "Total nilai transaksi Game dari tim tiga tingkat — Anda, anggota level 1, dan anggota level 2 — menentukan level Anda. Semakin tinggi nilai transaksi, semakin tinggi level dan semakin besar pendapatan komisi Anda.",
      rewardTitle: "Komponen Reward",
      rewards: ["Komisi level 1: memperoleh komisi langsung dari nilai transaksi Game anggota level 1.", "Komisi level 2: jika level anggota level 1 lebih rendah daripada level Anda, Anda dapat memperoleh reward tambahan dari anggota level 2 berdasarkan selisih persentase komisi."],
      tierTitle: "Tabel Level Komisi Game",
      tierLabel: "Tabel level komisi Game",
      tierHeaders: ["Level", "Total Transaksi Game Tim 30 Hari", "Komisi"],
      tierNote: "Level Anda ditentukan berdasarkan total transaksi Game tim selama 30 hari.",
      assessmentTitle: "Aturan Penyaluran Reward dan Penilaian Level",
      assessments: ["Setiap hari pukul 00.00, sistem menghitung total nilai transaksi tim Anda selama 30 hari sebelumnya untuk menentukan level Anda.", "Reward untuk hari sebelumnya kemudian dihitung dan diselesaikan berdasarkan level yang telah ditetapkan."],
      exampleTitle: "Contoh Sederhana",
      examples: ["Jika level Anda adalah Lv.5, Anda memperoleh reward sebesar 0,5% dari nilai transaksi yang dihasilkan anggota level 1.", "Jika level Anda adalah Lv.5 dan salah satu anggota level 1 berada di Lv.3, Anda memperoleh reward sebesar 0,2% dari nilai Game anggota level 2 yang dibawa oleh anggota level 1 tersebut. Selisih persentase komisi adalah 0,2% (0,5% - 0,3%).", "Jika level Anda adalah Lv.5 dan salah satu anggota level 1 juga berada di Lv.5, nilai transaksi Game anggota level 2 yang dibawanya tidak memberikan reward kepada Anda karena selisih persentasenya 0 (0,5% - 0,5%)."],
      detailTitle: "Penjelasan Rinci dengan Contoh",
      detailTeamTitle: "Tim C (anggota level 1 A)",
      detailTeams: [
        { title: "tingkat team A ", lines: ["Taruhan game sendiri + taruhan pengguna tingkat pertama + taruhan pengguna tingkat kedua", "Tim A: taruhan A + B + C + D + E + F + G = 10M + 20M + 10M + 5M + 800M + 200M + 10M = 1055M.", "Jadi lvl nya lvl 5 ,dan  komisi 0,5%."] },
        { title: "Tingkat Tim B (anggota level 1 A)", lines: ["taruhan B + E + F = 20M + 800M + 200M = 1.020M.", "Level Lv.5, persentase komisi 0,5%"] },
        { title: "Tim C anggota level 1 A", lines: ["Taruhan C + G = 20M.", "Level Lv.2, komisi 0,2%."] }
      ],
      detailIncomeTitle: "Pendapatan pengguna A:",
      detailIncomeGroups: [
        { title: "Cashback langsung dari pengguna level 1 B, C, dan D:", lines: ["(Taruhan sendiri B + C + D) × persentase cashback A = (20M + 10M + 5M) × 0,5% = 175.000 Koin (setara USD 17,50)."] },
        { title: "Cashback selisih level dari pengguna level 2 E, F, dan G:", lines: ["Dari E dan F: (komisi A − komisi B) × (E + F) = (0,5% − 0,5%) × (800M + 200M) = USD 0. Karena persentase komisi B sama dengan A, selisihnya 0 sehingga tidak ada reward.", "Dari G: (komisi A − komisi C) × G = (0,5% − 0,2%) × 10M = 0,3% × 10M = 30.000 Koin (setara USD 3,00). Karena komisi A lebih tinggi 0,3% daripada C, A memperoleh reward sebesar 0,3% dari transaksi G."] }
      ]
    },
    income: {
      title: "Aturan Komisi Pendapatan",
      levelTitle: "Sistem Level Komisi Pendapatan",
      levelText: "Total pendapatan tim tiga tingkat — Anda, anggota level 1, dan anggota level 2 — menentukan level Anda. Semakin tinggi pendapatan tim, semakin tinggi level dan semakin besar pendapatan komisi Anda.",
      rewardTitle: "Komponen Reward",
      rewards: ["Pendapatan Anda sendiri.", "Pendapatan anggota level 1.", "Pendapatan anggota level 2."],
      tierTitle: "Tabel Level Komisi Pendapatan",
      tierLabel: "Tabel level komisi pendapatan",
      tierHeaders: ["Level", "Pendapatan Bean dalam 30 Hari Terakhir", "Komisi"],
      tierNote: "Level Anda ditentukan berdasarkan total pendapatan tim selama 30 hari terakhir.",
      sPlusTitle: "Level S+",
      sPlus: ["Jika terdapat dua anggota level 1 dalam tim Anda yang mencapai level S, Anda akan naik ke level S+.", "Level S+ memiliki komisi sebesar 21%."],
      sPlusTierText: "Memiliki 2 level 1 dari lvl S",
      assessmentTitle: "Aturan Penyaluran Reward dan Penilaian Level",
      assessments: ["Setiap hari pukul 00.00, sistem menghitung total pendapatan tim Anda selama 30 hari sebelumnya untuk menentukan level Anda.", "Reward untuk hari sebelumnya kemudian dihitung dan diselesaikan berdasarkan level yang telah ditetapkan."],
      exampleTitle: "Contoh Sederhana",
      examples: ["Contoh 1: Jika level Anda adalah S, Anda memperoleh reward Bean sebesar 20% dari setiap pendapatan hadiah milik Anda sendiri.", "Contoh 2: Jika level Anda adalah S dan anggota level 1 Anda berada di level A, Anda memperoleh reward Bean sebesar 2% dari pendapatan hadiah anggota level 1 tersebut serta anggota level 2 yang dibawanya. Selisih persentase level adalah 20% - 18% = 2%.", "Contoh 3: Jika level Anda adalah S dan salah satu anggota level 1 Anda juga berada di level S, Anda tidak bisa memperoleh komisi dari anggota level 1 tersebut.", "Contoh 4: Jika 2 anggota level 1 Anda berada di level S, Anda akan menjadi S+ dengan persentase komisi 21%. Anda masih dapat memperoleh reward sebesar 1% dari pendapatan mereka."],
      noticeTitle: "Hal yang Perlu Diperhatikan",
      notices: ["Jika anggota tim Anda bergabung dengan agency, mereka tidak akan lagi memberikan pembagian pendapatan kepada Anda, tetapi pendapatan mereka tetap dicatat dalam total pendapatan tim dan digunakan untuk menghitung level komisi Anda.", "Level ditentukan berdasarkan pendapatan Bean dari hadiah tim selama 30 hari terakhir.", "Pendapatan hanya dapat dihitung setelah akun terverifikasi sebagai host."],
      detailTitle: "Penjelasan Rinci dengan Contoh",
      detailGroups: [
        {
          title: "Perhitungan level tim:",
          numberedLines: [
            "Level tim A: Pendapatan A + B + C + D + E + F = 20M + 156M + 98M + 40M + 4M + 2M = 320M. Level S, komisi 20%.",
            "Level tim B: Pendapatan B + D + E = 156M + 40M + 4M = 200M. Level A, komisi 18%.",
            "Level tim C: Pendapatan C + F = 98M + 2M = 100M. Level A, komisi 18%."
          ]
        },
        {
          title: "Perhitungan pendapatan A:",
          numberedLines: [
            "Pendapatan sendiri: Pendapatan A × komisi level A = 20M × 20% = 4.000.000 Bean.",
            "Anggota B: Pendapatan B × (komisi A - komisi B) = 156M × (20% - 18%) = 3.120.000 Bean.",
            "Anggota C: Pendapatan C × (komisi A - komisi C) = 98M × (20% - 18%) = 1.960.000 Bean.",
            "Anggota D dan E (dari B): (Pendapatan D + Pendapatan E) × (komisi A - komisi B) = (40M + 4M) × (20% - 18%) = 880.000 Bean.",
            "F (dari C): Pendapatan F × (komisi A - komisi C) = 2M × (20% - 18%) = 40.000 Bean"
          ]
        },
        {
          title: "Total",
          numberedLines: [
            "Pendapatan tambahan dari pendapatan sendiri: 4M Bean",
            "Pendapatan dari selisih tingkat komisi undangan: 3,12M + 1,96M + 0,88M + 0,04M = 6M Bean",
            "Total pendapatan: 10M Bean"
          ]
        }
      ]
    },
    recharge: {
      title: "Aturan Bonus Top Up",
      cashbackTitle: "Cashback Top Up",
      cashback: ["Selama 30 hari sejak teman yang Anda undang mendaftar, setiap top up yang dilakukan teman tersebut akan memberikan cashback kepada Anda.", "Teman yang diundang oleh teman Anda juga akan memberikan cashback kepada Anda atas top up yang dilakukan dalam 30 hari sejak pendaftarannya."],
      chainTitle: "Rantai Undangan",
      chainIntro: "Contoh hubungan: A mengundang B, B mengundang C, dan C mengundang D.",
      chainAlt: "Diagram rantai undangan A, B, C, dan D",
      chainExamples: ["B melakukan top up 10.000 Koin. A akan memperoleh 200 Koin (cashback 2%).", "C melakukan top up 10.000 Koin. B akan memperoleh 200 Koin (cashback 2%), sedangkan A akan memperoleh 100 Koin (cashback 1%).", "D melakukan top up 10.000 Koin. C akan memperoleh 200 Koin (cashback 2%), B akan memperoleh 100 Koin (cashback 1%), dan A tidak lagi memperoleh cashback dari top up D.", "Undangan langsung level 1 memberikan cashback sebesar 2%.", "Undangan tidak langsung level 2 memberikan cashback sebesar 1%."],
      validityTitle: "Masa Berlaku 30 Hari",
      validity: ["Semua top up yang dilakukan teman yang diundang dalam 30 hari sejak tanggal pendaftaran akan memberikan cashback kepada upline yang memenuhi syarat.", "Setelah 30 hari, top up yang dilakukan tidak lagi memberikan cashback apa pun."],
      payoutTitle: "Aturan Penyaluran Reward",
      payout: ["Setelah pengguna menyelesaikan top up, reward akan dikreditkan ke dompet Anda secara real-time.", "Metode top up yang diperhitungkan meliputi: top up melalui apk dan top up melalui reseller."]
    }
  },
  rewardSourceDetail: {
    "title": "Detail sumber hadiah",
    "rules": "Aturan",
    "activityEarnings": "Aktif",
    "rechargeEarnings": "Top Up",
    "gameCommission": "Game",
    "incomeCommission": "Pendapatan",
    "totalEarnings": "Total",
    "yesterdayEarnings": "Kemarin",
    "todayEstimate": "Hari ini",
    "todayActiveUsers": "Pengguna aktif",
    "currentRankReward": "Hadiah saat ini",
    "upgradeReward": "{count} lagi aktif untuk naik ke {reward}",
    "maxRewardTier": "Sudah tier hadiah maksimal",
    "teamRevenue": "Total revenue tim 30 hari",
    "currentCommission": "Komisi saat ini",
    "upgradeCommission": "Butuh {flow} revenue untuk capai {rate}",
    "maxCommissionTier": "Sudah tier komisi maksimal",
    "invitedUsers": "Pengguna diundang 7 hari",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "certified": "Terverifikasi",
    "agency": "Agency",
    "micTime": "Waktu on mic",
    "minutes": "mnt",
    "gameRevenue": "Revenue game",
    "coins": "Koin",
    "loading": "Memuat...",
    "noMore": "Tidak ada lagi",
    "noData": "Tidak ada data",
    "total": "Total",
    "last7Days": "7 hari terakhir",
    "yesterday": "Kemarin",
    "today": "Hari ini",
    "level1Commission": "Komisi level 1",
    "level2Commission": "Komisi level 2",
    "totalIncome": "Total pendapatan",
    "commissionRate": "Tingkat komisi",
    "upgradeGap": "{amount} lagi untuk naik",
    "activeHelpUpdate": "Data diperbarui 10-15 menit",
    "activeHelpReward": "Hadiah dapat diambil halaman Beranda-Hadiah pukul 10.00 hari berikutnya",
    "rechargeHelpUpdate": "Data diperbarui 10-15 menit",
    "rechargeHelpReward": "Hadiah masuk segera setelah pengguna top-up",
    "gameHelpUpdate": "Data diperbarui 10-15 menit",
    "gameHelpReward": "Hadiah diberikan sistem hari berikutnya",
    "roomHelpUpdate": "Data diperbarui 10-15 menit",
    "roomHelpCommission": "Termasuk: komisi Anda, anggota Level 1 & Level 2",
    "roomHelpReward": "Hadiah diberikan sistem hari berikutnya",
    "back": "Kembali",
    "viewHelp": "Lihat penjelasan",
    "todayEstimateHelp": "Penjelasan estimasi hari ini"
  },
};
